import { Backdrop, CircularProgress, Fade } from "@mui/material";
import { DivPaperStyled, ModalStyled } from "../Modals.styled";
import { KTSVG } from "../../../_metronic/helpers";
import { InputStyled } from "../Inputs.styled";
import { ButtonStyled } from "../ShippingItemsPage/ShippingItemsPage.styled";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../setup";
import { modalStyles } from "../ModalStyles";
import axios from "axios";
import { checkErrorAPICall } from "../../helpers/checkErrorAPICall";

const TradeShowModal = ({open, setOpen, formik, formFor}) => {
    const [saving, setSaving] = useState(false)
    const [saved, setSaved] = useState(false)
    const dispatch = useDispatch()
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    const classes = modalStyles({fontSize: fontSize})
    const [values, setValues] = useState({
        showName: '',
        venueName: '',
        booth: ''
    })

    const handleClose = () => {
        setOpen(false)
        setTimeout(() => {
            setValues({
                showName: '',
                venueName: '',
                booth: ''
             })
        }, 500);
    }

    useEffect(() => {
      if(open){
        setValues({
            showName: formik.values[formFor].tradeShow?.showName,
            venueName: formik.values[formFor].tradeShow?.venueName,
            booth: formik.values[formFor].tradeShow?.booth
        })
      }
    }, [open])

    return (
        <>
            <ModalStyled
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                fontSize={fontSize}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <DivPaperStyled className={classes.paper}>
                        <div className="row modal-header p-0 pb-2">
                            <div className="col-8">
                                <h5 className="modal-title">Trade Show Information</h5>
                            </div>
                            <div className="col-1 d-flex btn btn-icon btn-sm btn-active-light-primary me-3" onClick={handleClose}>
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-2x"
                                />
                            </div>
                        </div>
                            <>
                                <div className="row mb-4 mt-4">
                                    <div className="col-4">
                                        <label className='form-label'>Show Name</label>
                                    </div>
                                    <div className="col-8">
                                        <InputStyled
                                            maxLength="50"
                                            type="text"
                                            className="form-control"
                                            autoComplete='off'
                                            fontSize={fontSize}
                                            value={values.showName}
                                            onChange={(e) => {
                                                setValues({
                                                    ...values,
                                                    showName: e.target.value
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col-4">
                                        <label className='form-label'>Venue Name</label>
                                    </div>
                                    <div className="col-8">
                                        <InputStyled
                                            maxLength="50"
                                            type="text"
                                            className="form-control"
                                            autoComplete='off'
                                            fontSize={fontSize}
                                            value={values.venueName}
                                            onChange={(e) => {
                                                setValues({
                                                    ...values,
                                                    venueName: e.target.value
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-4">
                                    <div className="col-4">
                                        <label className='form-label'>Booth</label>
                                    </div>
                                    <div className="col-8">
                                        <InputStyled
                                            maxLength="20"
                                            type="text"
                                            className="form-control"
                                            autoComplete='off'
                                            fontSize={fontSize}
                                            value={values.booth}
                                            onChange={(e) => {
                                                setValues({
                                                    ...values,
                                                    booth: e.target.value
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-12 d-flex justify-content-end pt-7 pt-sm-0">
                                        <button
                                            className="btn btn-secondary me-4"
                                            onClick={handleClose}
                                        >
                                            Close
                                        </button>
                                        <ButtonStyled
                                            className={`btn ${saved ? 'btn-success' : 'btn-primary'} d-flex align-items-center`}
                                            saved={saved}
                                            type='submit'
                                            onClick={() => {
                                                formik.setFieldValue(`${formFor}.tradeShow.showName`, values.showName)
                                                formik.setFieldValue(`${formFor}.tradeShow.venueName`, values.venueName)
                                                formik.setFieldValue(`${formFor}.tradeShow.booth`, values.booth)
                                                setOpen(false)
                                            }}
                                        >
                                            {saving ? 'Saving' : saved ? 'Saved' : 'Save'}{saving && <CircularProgress style={{height: 16, width: 16, color: 'white'}} className='ms-2'/>}
                                        </ButtonStyled>
                                    </div>
                                </div>
                            </>
                    </DivPaperStyled>
                </Fade>
            </ModalStyled>
        </>
    )
}

export default TradeShowModal